import { useMemo } from 'react';

import { useTypedSelector } from 'hooks/useTypedSelector';

export const useShowFormNHSLogo = (): { showFormNHSLogo: boolean } => {
  const selectedService = useTypedSelector(state => state.form.selectedService);

  const showFormNHSLogo = useMemo(
    () => !!selectedService?.serviceTypes?.some(serviceType => serviceType.title === 'NHS England'),
    [selectedService],
  );

  return { showFormNHSLogo };
};
